import React from 'react';
import axios from "../../../containers/api";
import {showCatchError} from "../../../helpers/Utils";
import {Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, Badge} from "reactstrap";
import {Table} from "../../../components/table/Table";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import NewUserModal from "../../../components/admin/NewUserModal";
import AddMainBranch from "./components/AddMainBranch";
import EditMainBranch from "./components/EditMainBranch";
import MainBranchAgencies from "./components/MainBranchAgencies";

class MainBranchIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            AgentMains: null,
            showAgenciesModal: false,
            AgentId: null,
            AgentMainToEdit: null,
            AllAgencies: [],
            Agencies: [],
            EditModal: false,
            showNewMemberModal: false,
            AddModal: false
        }
    }

    componentDidMount() {
        this.CheckMemberTypeIsAdmin();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    this.GetMainAgencies();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    GetMainAgencies = () => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/GetMainAgencies')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({AgentMains: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    getAgencies = () => {
        this.props.showSpinner();
        axios.get('api/AgencyApi/GetAgencies')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({AllAgencies: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    changePassword = (username) => {
        this.props.closeSweetAlert();
        if (username === null || username === '') {
            this.props.showAlert('نام کاربری معتبر نمی باشد.', 'error');
            return;
        }

        this.props.showSpinner();
        axios.post('api/ClientApi/ChangeMemberPasswordAdmin?username=' + 'AM' + username, {
            Id: this.state.customerRequestId,
            RejectReason: this.state.rejectReason
        })
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert("رمز عبور با موفقیت تغییر کرد", "success");
                this.setState({
                    newMemberUsername: res.data.username,
                    newMemberPassword: res.data.password,
                    showNewMemberModal: true
                });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    openModal = (modalName, item) => {
        if (modalName === "showAgenciesModal") {
            if (this.state.AllAgencies.length === 0) {
                this.getAgencies();
            }
            this.setState({
                [modalName]: true,
                AgentMainToEdit: item
            });
        }
    }
    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        this.GetMainAgencies();
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>مدیریت دفاتر مرکزی</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                    <Button outline color="primary" className="mx-3"
                                            onClick={() => this.setState({AddModal: true})}>
                                        افزودن دفتر مرکزی جدید
                                    </Button>
                                </div>

                                <Table
                                    tableHeaders={[
                                        "نام کاربری",
                                        "نام",
                                        "نام مدیر",
                                        "آدرس",
                                        "تلفن",
                                        "کد ملی",
                                        "وضعیت",
                                        "نمایندگان",
                                        "ویرایش",
                                        "رمز عبور",
                                    ]}

                                    tableRow={this.state.AgentMains !== null ? this.state.AgentMains : []}

                                    tableData={[
                                        customer => {
                                            return "AM" + customer.agentMainNationID;
                                        },
                                        customer => {
                                            return customer.agentMainName;
                                        },
                                        customer => {
                                            return customer.agentMainManagerName;
                                        },
                                        customer => {
                                            return customer.agentMainAddress;
                                        },
                                        customer => {
                                            return customer.agentMainTel;
                                        },
                                        customer => {
                                            return customer.agentMainNationID;
                                        },
                                        customer => {
                                            return (
                                                customer.active === true ?
                                                    <Badge color="outline-success" pill>فعال</Badge>
                                                    :
                                                    <Badge color="outline-danger" pill>غیرفعال</Badge>
                                            )
                                        },
                                        customer => {
                                            return (
                                                <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("showAgenciesModal", customer)}>
                                                    نمایندگی‌ها
                                                </Button>
                                            )
                                        },
                                        customer => {
                                            return (
                                                <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({AgentMainToEdit: customer, EditModal: true})}>
                                                    ویرایش
                                                </Button>
                                            )
                                        },
                                        customer => {
                                            return (
                                                <Button outline color="warning" size="sm"
                                                        onClick={() => this.props.showSweetAlert("آیا رمز عبور این دفتر مرکزی تغییر کند؟", "", "warning", () => this.changePassword(customer.agentMainNationID))}>
                                                    تغییر رمز
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.AddModal} size="xlg" toggle={() => this.closeModal("AddModal")}>
                    <ModalHeader toggle={() => this.closeModal("AddModal")}>
                        افزودن دفتر مرکزی جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddMainBranch
                            isModal={true}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.EditModal} size="xlg" toggle={() => this.setState({EditModal: false})}>
                    <ModalHeader toggle={() => this.setState({EditModal: false})}>
                        ویرایش دفتر مرکزی
                        {" "}
                        {this.state.AgentMainToEdit && this.state.AgentMainToEdit.agentMainName}
                    </ModalHeader>
                    <ModalBody>
                        <EditMainBranch
                            AgentMainToEdit={this.state.AgentMainToEdit}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.showAgenciesModal} size="xlg" toggle={() => this.setState({showAgenciesModal: false})}>
                    <ModalHeader toggle={() => this.setState({showAgenciesModal: false})}>
                        نمایندگی‌ها
                    </ModalHeader>
                    <ModalBody>
                        <MainBranchAgencies
                            AllAgencies={this.state.AllAgencies}
                            AgentMainToEdit={this.state.AgentMainToEdit}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                    <ModalHeader toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <NewUserModal
                            newMemberUsername={this.state.newMemberUsername}
                            newMemberPassword={this.state.newMemberPassword}
                        />
                    </ModalBody>
                </Modal>

            </>
        );
    }
}

export default MainBranchIndex;